export enum WineType {
    Bollicine,
    Bianchi,
    Rossi,
    Rosati,
    Dolci
}
export interface wine {
    type?: WineType;
    nome: string;
    cantina: string;
    descrizione: string;
    caratteristiche : string[];
    vol: string;
    annata: string;
    bottlePrice: number;
    chalicePrice: number;
}